// sharedState.js
import { reactive } from 'vue';

export const chatbotState = reactive({
  chatbot: { chatbotId:"" },
});

